export default "__VITE_ASSET__1Byq3pPW__"